import {createFileRoute, notFound} from "@tanstack/react-router";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {isDuluxWorkspace} from "~/domainModels/workspaceSpecific/dulux";
import {DuluxDashboardPageView} from "~/workspaceConfig/hostedPages/duluxDashboard/-routeComponent";
import {
    DULUX_AID_DASHBOARD_DATASET_ID,
    DULUX_DASHBOARD_DATASET_ID,
} from "~/workspaceConfig/hostedPages/dashboard/-dashboardConfig/duluxDashboardConfig";
import {getEratoDatasetDetails} from "~/workspaceConfig/hostedPages/dashboard/-api";
import {getDefaultThisMonthDateRangeIsoBounds} from "~/utilities/defaultDateRange";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_configScaffold/dulux-dashboard",
)({
    beforeLoad: ({context}) => {
        if (isDuluxWorkspace(context.workspaceCapabilities) !== true) {
            throw notFound();
        }
    },
    loader: async ({context}) => {
        const workspaceId: Uuid = context.workspace.id;
        const accessToken = context.authenticationStatus.accessToken;
        const {start, end} = getDefaultThisMonthDateRangeIsoBounds();
        const datasetResult = await getEratoDatasetDetails(
            DULUX_DASHBOARD_DATASET_ID,
            context.intellsysBaseUrl,
            accessToken,
            workspaceId,
            context.queryClient,
        );
        if (datasetResult.success !== true) {
            throw datasetResult.error;
        }
        const aidDatasetResult = await getEratoDatasetDetails(
            DULUX_AID_DASHBOARD_DATASET_ID,
            context.intellsysBaseUrl,
            accessToken,
            workspaceId,
            context.queryClient,
        );
        if (aidDatasetResult.success !== true) {
            throw aidDatasetResult.error;
        }

        return {
            dataset: datasetResult.data,
            aidDataset: aidDatasetResult.data,
            defaultRange: {start: start, end: end},
            workspaceUser: context.currentWorkspaceUser,
            platformUser: context.profileStatus.platformUser,
        };
    },
    component: DuluxDashboardRouteComponent,
});

function DuluxDashboardRouteComponent() {
    const {dataset, aidDataset, defaultRange, workspaceUser, platformUser} = Route.useLoaderData();
    return (
        <DuluxDashboardPageView
            dataset={dataset}
            aidDataset={aidDataset}
            defaultRange={defaultRange}
            workspaceUser={workspaceUser}
            platformUser={platformUser}
        />
    );
}
